
import {loginInfo} from '../../apis/user'

//用户个人数据仓库
const state = {

}
const mutations = {

}
const actions = {

}
const getters = {

}
 


export default {
    state,
    mutations,
    actions,
    getters
}